import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { FullTagDescription } from "@reduxjs/toolkit/dist/query/endpointDefinitions";

export const tagTypes = ["LIST", "ContentGroup","Content", "User","Comment", "Order", "Follow", "Fans", "Black", "UserSign", "MsuserChat", "Train"];
export type ApiFullTagDescription = FullTagDescription<(typeof tagTypes)[number]>;
export const LIST_TAG = "LIST";


function getCSRFFromCookie() {
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith('MMCSRF=')) {
              return cookie.replace('MMCSRF=', '');
          }
      }
  }
  return '';
}

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const baseUrl = "";
  const authToken = localStorage.getItem("token");

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: `${baseUrl ?? ""}/api/v4`,
    prepareHeaders: (headers) => {
      if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
      }
      headers.set("X-Requested-With","XMLHttpRequest")
      headers.set("X-CSRF-Token",getCSRFFromCookie())
      return headers;
    },
  });
  return rawBaseQuery(args, api, extraOptions);
};

export const api = createApi({
  baseQuery: dynamicBaseQuery,
  reducerPath: "api",
  tagTypes,
  endpoints: () => ({}),
});
